export const SET_SURVEY_DATA = 'SET_SURVEY_DATA'
